// @flow

import React, {Component} from 'react';
import {connect} from 'react-redux';
import {withRouter} from 'react-router-dom';
import _ from 'lodash/fp';
import AdminList from '../../components/AdminList/AdminList';
import SelectFormInput from '../../components/SelectFormInput/SelectFormInput';
import LoadingIndicator from '../../components/LoadingIndicator/LoadingIndicator';
import SearchField from '../../components/SearchField/SearchField';
import {
  fetchProducts,
  fetchProductTypes,
  filterProducts,
  sortItems,
} from '../../actions/productList';
import booleanValues from '../../booleanValues';
import ReactTooltip from 'react-tooltip';

const hasRelatedFormatter = variant => (hasRelated, {rowIndex}) =>
  !!hasRelated
    ? (
      <div
        data-tip
        data-for={`has-related-tip-${rowIndex}`}>
        <ReactTooltip
          id={`has-related-tip-${rowIndex}`}
          effect="solid">
          <span>{!!variant
            ? 'Varianten tillhör'
            : 'Detta är'
          } en kombinationsprodukt</span>
        </ReactTooltip>
        <i className="fa fa-code-fork" />
      </div>
    )
    : '';

const variantColumns = [{
  property: 'externalItemNumber',
  header: {
    label: 'Artikelnummer',
  },
}, {
  property: 'name',
  header: {
    label: 'Namn',
  },
}, {
  property: 'product.productType.name',
  header: {
    label: 'Produkttyp',
  },
}, {
  property: 'sellingPrice',
  header: {
    label: 'Pris',
  },
}, {
  property: 'hasRelated',
  header: {
    label: '',
  },
  cell: {
    formatters: [
      hasRelatedFormatter(true),
    ],
  },
}];

const productColumns = [{
  property: 'mainVariant.externalItemNumber',
  header: {
    label: 'Artikelnummer',
  },
}, {
  property: 'name',
  header: {
    label: 'Namn',
  },
}, {
  property: 'productType.name',
  header: {
    label: 'Produkttyp',
  },
}, {
  property: 'mainVariant.sellingPrice',
  header: {
    label: 'Pris',
  },
}, {
  property: 'hasRelated',
  header: {
    label: '',
  },
  cell: {
    formatters: [
      hasRelatedFormatter(false),
    ],
  },
}];

export type Props = {
  history: Object,
  fetchData: Function,
  filterProducts: Function,
  location: { pathname: string },
  list: any[],
  productTypes: any[],
  productTypesIsFetching: boolean,
  filter: {
    archived: boolean,
    productType: ?number,
    query: ?string,
    showVariants: boolean,
  },
  isFetching: boolean,
  sortItems: typeof sortItems,
};

class ProductsContainer extends Component<Props> {
  props: Props;

  componentWillMount() {
    this.props.fetchData();
  }

  render() {
    const {
      history,
      filter,
      productTypes,
      filterProducts,
      productTypesIsFetching,
      location: {pathname},
      isFetching,
      list,
      sortItems,
    } = this.props;
    return (
      <div className="ProductsContainer relative">
        <LoadingIndicator isLoading={isFetching} />
        <div className="row align-middle">
          <div className="column">
            <SearchField
              value={filter.query || ''}
              onClear={e => filterProducts({
                ...filter,
                query: '',
              })}
              onChange={e => filterProducts({
                ...filter,
                query: e.target.value,
              })} />
          </div>
          <div className="column shrink">
            <button
              type="button"
              className="primary button"
              onClick={() => history.push(`${pathname}/new`)}>
                Skapa ny
            </button>
          </div>
        </div>
        <div className="box">
          <div className="row align-middle">
            <div className="column">
              <SelectFormInput
                input={{
                  value: filter.productType || null,
                  onBlur: _.noop,
                  onChange: type => filterProducts({
                    ...filter,
                    productType: type ? type.id : null,
                  }),
                }}
                label="Produkttyp"
                meta={{}}
                valueKey="id"
                labelKey="name"
                clearable={true}
                options={productTypes}
                isLoading={productTypesIsFetching} />
            </div>
            <div className="column">
              <SelectFormInput
                input={{
                  value: !!filter.archived,
                  onBlur: _.noop,
                  onChange: archived => filterProducts({
                    ...filter,
                    archived: archived ? archived.value : false,
                  }),
                }}
                label="Arkiverade"
                meta={{}}
                valueKey="value"
                labelKey="label"
                clearable={false}
                options={booleanValues} />
            </div>
            <div className="column">
              <SelectFormInput
                input={{
                  value: !!filter.showVariants,
                  onBlur: _.noop,
                  onChange: show => filterProducts({
                    ...filter,
                    showVariants: show ? show.value : false,
                  }),
                }}
                label="Visa varianter"
                meta={{}}
                valueKey="value"
                labelKey="label"
                clearable={false}
                options={booleanValues} />
            </div>
          </div>
          {list &&
            <AdminList
              columns={filter.showVariants ? variantColumns : productColumns}
              rows={list}
              onSort={sortItems}
              onRowSelected={row => {
                let path = `${pathname}/`;
                if (!!filter.showVariants) {
                  path += `${row.product.id}/variants/${row.id}`;
                } else {
                  path += row.id;
                }
                history.push(path);
              }} />
          }
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({
  productList: {
    filter,
    isFetching,
    filteredList: list,
    productTypes: {
      isFetching: productTypesIsFetching,
      list: productTypes,
    },
  },
}) => ({
  filter,
  isFetching,
  list,
  productTypes,
  productTypesIsFetching,
});

const mapDispatchToProps = dispatch => ({
  fetchData: () => {
    dispatch(fetchProducts());
    dispatch(fetchProductTypes());
  },
  filterProducts: filter =>
    dispatch(filterProducts(filter)),
  sortItems: sorter =>
    dispatch(sortItems(sorter)),
});

export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(ProductsContainer));



// WEBPACK FOOTER //
// ./src/containers/ProductsContainer/ProductsContainer.js